import { render, staticRenderFns } from "./positions.vue?vue&type=template&id=a607e50a&scoped=true&"
import script from "./positions.vue?vue&type=script&lang=js&"
export * from "./positions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a607e50a",
  null
  
)

export default component.exports